/* FNDRY — Shop by concern
   Plain JS, no framework. The first option ships open from Liquid, so a broken
   script degrades to a static, readable section rather than a blank one. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-fndry-sbc]';
  var hoverQuery = null;

  function canHover() {
    if (!window.matchMedia) return false;
    if (!hoverQuery) hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    return hoverQuery.matches;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-sbc-ready') === 'true') return;

    var options = toArray(root.querySelectorAll('[data-sbc-option]'));
    var layers = toArray(root.querySelectorAll('[data-sbc-layer]'));
    if (!options.length) return;

    root.setAttribute('data-sbc-ready', 'true');

    var triggers = options.map(function (option) {
      return option.querySelector('[data-sbc-trigger]');
    });

    var current = 0;
    options.forEach(function (option, index) {
      if (option.classList.contains('is-active')) current = index;
    });

    function activate(index) {
      if (index < 0 || index >= options.length) return;
      current = index;

      options.forEach(function (option, i) {
        var on = i === index;
        option.classList.toggle('is-active', on);

        var trigger = triggers[i];
        if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');

        var body = option.querySelector('[data-sbc-body]');
        if (body) body.setAttribute('aria-hidden', on ? 'false' : 'true');

        // Keep the collapsed CTA out of the tab order — it is visually hidden.
        var cta = option.querySelector('[data-sbc-cta]');
        if (cta) cta.setAttribute('tabindex', on ? '0' : '-1');
      });

      layers.forEach(function (layer, i) {
        layer.classList.toggle('is-active', i === index);
      });
    }

    function focusTrigger(index) {
      var trigger = triggers[index];
      if (!trigger) return;
      trigger.focus({ preventScroll: true });
    }

    function onKeydown(event) {
      var key = event.key;
      var last = options.length - 1;
      var next = null;

      if (key === 'ArrowDown' || key === 'ArrowRight') next = current >= last ? 0 : current + 1;
      else if (key === 'ArrowUp' || key === 'ArrowLeft') next = current <= 0 ? last : current - 1;
      else if (key === 'Home') next = 0;
      else if (key === 'End') next = last;

      if (next === null) return;
      event.preventDefault();
      activate(next);
      focusTrigger(next);
    }

    options.forEach(function (option, index) {
      // Desktop: hovering anywhere in the option area selects it.
      option.addEventListener('mouseenter', function () {
        if (canHover()) activate(index);
      });

      var trigger = triggers[index];
      if (!trigger) return;

      // Mobile (and any pointer): tap to select.
      trigger.addEventListener('click', function () {
        activate(index);
      });

      // Keyboard: focus opens, so a revealed CTA is always reachable.
      trigger.addEventListener('focus', function () {
        activate(index);
      });

      trigger.addEventListener('keydown', onKeydown);
    });

    activate(current);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    toArray(container.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      try {
        initSection(root);
      } catch (error) {
        // Never leave the section in a half-bound state.
        root.setAttribute('data-sbc-ready', 'true');
        if (window.console && console.warn) console.warn('fndry-shop-by-concern:', error);
      }
    });
  }

  function ready() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector(ROOT_SELECTOR);
    if (root) root.removeAttribute('data-sbc-ready');
  });

  // Selecting a block in the theme editor previews that option.
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest) return;
    var root = block.closest(ROOT_SELECTOR);
    if (!root) return;

    initAll(root.parentNode || document);

    var options = toArray(root.querySelectorAll('[data-sbc-option]'));
    var index = options.indexOf(block);
    if (index < 0) return;

    var trigger = block.querySelector('[data-sbc-trigger]');
    if (trigger) trigger.click();
  });
})();